import React from 'react';
import { DPadControlsProps } from '../../types/swipeable';

export const DPadControls: React.FC<DPadControlsProps> = ({
  onUp,
  onDown,
  onLeft,
  onRight,
  canSwipeUp,
  canSwipeDown,
  canSwipeLeft,
  canSwipeRight
}) => {
  return (
    <div className="qwipe-dpad">
      <div className="dpad-container">
        {/* 上ボタン */}
        <button
          className={`dpad-button dpad-up ${canSwipeUp ? 'enabled' : 'disabled'}`}
          onClick={canSwipeUp ? onUp : undefined}
        >
          ▲
        </button>
        
        {/* 下ボタン */}
        <button
          className={`dpad-button dpad-down ${canSwipeDown ? 'enabled' : 'disabled'}`}
          onClick={canSwipeDown ? onDown : undefined}
        >
          ▼
        </button>
        
        {/* 左ボタン */}
        <button
          className={`dpad-button dpad-left ${canSwipeLeft ? 'enabled' : 'disabled'}`}
          onClick={canSwipeLeft ? onLeft : undefined}
        >
          ◀
        </button>
        
        {/* 右ボタン */}
        <button
          className={`dpad-button dpad-right ${canSwipeRight ? 'enabled' : 'disabled'}`}
          onClick={canSwipeRight ? onRight : undefined}
        >
          ▶
        </button>
        
        {/* 中央の円形 */}
        <div className="dpad-center"></div>
      </div>
    </div>
  );
};
